/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import fbEvents from './static/fb.tracker';
// import googleAnalytics from './static/analytics';

import "@fontsource/montserrat/latin-400.css";
import "@fontsource/montserrat/latin-500.css";
import "@fontsource/montserrat/latin-600.css";
import "@fontsource/montserrat/latin-700.css";
import "@fontsource/montserrat/latin-900.css";

import "@fontsource/roboto/latin-300.css";
import "@fontsource/roboto/latin-400.css";
import "@fontsource/roboto/latin-500.css";
import "@fontsource/roboto/latin-700.css";
import "@fontsource/roboto/latin-900.css";

import "@fontsource/dm-sans";


// gatsby-plugin-image race: if React hydrates before the plugin's inline script swaps a lazy
// image's data-src into src, the empty <img> reports complete=true, so the plugin drops the
// data-gatsby-image-ssr marker. Its fade-in listener then ignores the real load event and the
// image stays at opacity 0 behind the blurred placeholder. Reveal every main image once it loads.
const revealGatsbyImage = (event) => {
    const img = event.target;
    if (!img.dataset || img.dataset.mainImage === undefined) return;
    const wrapper = img.closest('[data-gatsby-image-wrapper]');
    const placeholder = wrapper && wrapper.querySelector('[data-placeholder-image]');
    const reveal = () => {
        img.style.opacity = 1;
        if (placeholder) placeholder.style.opacity = 0;
    };
    img.decode ? img.decode().catch(() => { }).then(reveal) : reveal();
}

export const onClientEntry = () => {
    // Registered before hydration, so it sees every load the plugin's own listener may skip
    document.addEventListener('load', revealGatsbyImage, true);
    fbEvents()
    // Currently set on seo.tsx, 
    // Should be activated here and removed from seo.tsx once tested and confirming new Analytics GA4 is configured correctly
    // googleAnalytics();
}